/**
 * Una tinta per committente, sempre la stessa in tutte le pagine.
 *
 * Ai committenti in anagrafica il colore lo assegna il server, uno diverso
 * per ciascuno nell'ordine in cui sono stati creati, e resta scritto sulla
 * scheda: così Italgas e AP non finiscono mai con lo stesso arancione. Un
 * nome scritto a mano, che in anagrafica non c'è, ricade sulle lettere.
 * Trasparenze bassissime: la griglia deve restare leggibile, il colore serve
 * solo al colpo d'occhio.
 */
export const TINTE = [
  "14 165 233",   // azzurro
  "249 115 22",   // arancione
  "16 185 129",   // verde
  "168 85 247",   // viola
  "244 63 94",    // rosa
  "234 179 8",    // giallo
  "99 102 241",   // indaco
  "20 184 166",   // acquamarina
  "132 204 22",   // lime
  "217 70 239",   // fucsia
  "180 83 9",     // marrone
  "71 85 105",    // ardesia
];

// Oltre la dodicesima tinta non si ricomincia da capo - due committenti con
// lo stesso colore sono proprio quello che non si vuole - ma si gira la
// ruota dei colori di un angolo irregolare, cosi' ogni indice ha la sua.
function tintaPerIndice(i) {
  if (i < TINTE.length) return TINTE[i];
  // Piu' scure e meno sature delle prime dodici: si distinguono anche da quelle.
  const h = ((i - TINTE.length) * 137.5 + 200) % 360;
  const s = 0.5, l = 0.36;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))));
  return `${f(0)} ${f(8)} ${f(4)}`;
}

// La tavolozza da cui si sceglie a mano, nella scheda del committente:
// ventiquattro colori ben distinti, con il nome per dirseli a voce.
export const TAVOLOZZA = [
  ["#0ea5e9", "azzurro"], ["#1d4ed8", "blu"], ["#0891b2", "petrolio"], ["#14b8a6", "acquamarina"],
  ["#10b981", "verde"], ["#15803d", "verde scuro"], ["#84cc16", "lime"], ["#eab308", "giallo"],
  ["#f97316", "arancione"], ["#dc2626", "rosso"], ["#be123c", "cremisi"], ["#f43f5e", "rosa"],
  ["#db2777", "fucsia"], ["#d946ef", "magenta"], ["#a855f7", "viola"], ["#7c3aed", "viola scuro"],
  ["#6366f1", "indaco"], ["#b45309", "marrone"], ["#9a3412", "ruggine"], ["#ca8a04", "senape"],
  ["#475569", "ardesia"], ["#4b5563", "grigio"], ["#065f46", "bosco"], ["#000000", "nero"],
];

export function hexARgb(hex) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  return m ? `${parseInt(m[1], 16)} ${parseInt(m[2], 16)} ${parseInt(m[3], 16)}` : null;
}

// Il colore di un committente com'e' registrato: l'esadecimale scelto a mano
// oppure l'indice assegnato dal server.
export function tintaDaValore(valore) {
  if (valore == null) return null;
  if (typeof valore === "string") return hexARgb(valore);
  return tintaPerIndice(valore);
}

export function tintaCommittente(nome, colori) {
  if (!nome) return null;
  if (colori && colori[nome] != null) return tintaDaValore(colori[nome]);
  let n = 0;
  for (let i = 0; i < nome.length; i += 1) n = (n * 31 + nome.charCodeAt(i)) % 9973;
  return TINTE[n % TINTE.length];
}
